import { IgSelect, IgTextField, IgTypography } from "@intelligems/ig-theme";
import {
  LandingPageFilterList,
  LandingPageFilterType,
} from "@intelligems/ig-types";
import { Grid, MenuItem } from "@mui/material";

export interface LandingPageFilterProps {
  value: string | null;
  filter: LandingPageFilterType | null;
  onChange: (
    value: string | null,
    filter: LandingPageFilterType | null
  ) => void;
}

export const LandingPageFilter = ({
  value,
  filter,
  onChange,
}: LandingPageFilterProps) => {
  const isNullable = ["isNull", "isNotNull"].includes(filter || "");
  const options = LandingPageFilterList.map((option) => ({
    value: option,
    label: option.replace(/([A-Z])/g, " $1").toLowerCase(),
  }));

  return (
    <Grid item container direction="row" columnGap={2}>
      <Grid item>
        <IgSelect
          variant="outlined"
          value={filter || options[0].value}
          onChange={(e) => {
            if (["isNull", "isNotNull"].includes(e.target.value)) {
              onChange(null, e.target.value);
            } else {
              onChange(value, e.target.value);
            }
          }}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <IgTypography>{option.label}</IgTypography>
            </MenuItem>
          ))}
        </IgSelect>
      </Grid>
      {!isNullable && (
        <Grid item>
          <IgTextField
            fullWidth={true}
            value={value || ""}
            onChange={(e) => {
              const value = e.target.value;
              if (value) {
                onChange(e.target.value, filter || options[0].value);
              }
            }}
          />
        </Grid>
      )}
    </Grid>
  );
};
